import db from '../firebaseInit';
import {NOTIFICATION_SETTINGS} from './../constants/globalConstants';

const getUserDataFromFirebase = (userId, callbackFunc = null) => {
  if (!userId) return;
  const docRef = db.collection('users').doc(userId);
  docRef
    .get()
    .then(document => {
      if (document.exists) {
        const currentUserData = document.data();
        callbackFunc(currentUserData);
      } else {
        this.$snotify.error('Error getting getting user data', '', NOTIFICATION_SETTINGS);
      }
    })
    .catch(function(error) {
      this.$snotify.error('Error getting getting user data', '', NOTIFICATION_SETTINGS);
    });
};

export default getUserDataFromFirebase;
